import React, { useEffect, useState } from 'react';
import { instanceOf } from 'prop-types';
import { withRouter, browserHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Stomp } from '@stomp/stompjs';
import * as urls from '../../actions/urlTypes';
import DistributeView from '../../components/enablement/DistributeView';
import { checkUnsavedChanges, _updateStatus } from '../../actions/deActions/deDistributeActions';

const Distribute = props => {
  let navConfirmed = false;
  const [routerLeaveModal, setRouterLeaveModal] = useState(false);
  const [nextLocation, setNextLocation] = useState('');
  const loginState = useSelector(state => state.login.loginResponse)
  const activeAccountId = useSelector(state => state.account.activeAccountId)
  const dispatch = useDispatch();

  const socketURL = `${urls.WS_BASE_URL}/websocket-service/insights-websocket`;

  const confirmNavigation = () => {
    navConfirmed = true;
    setRouterLeaveModal(false);
    browserHistory.push(nextLocation);
  };

  const resetRouterLocation = () => {
    setRouterLeaveModal('');
    setNextLocation('');
  };

  const routerWillLeave = nextLocation => {
    const hasUnsavedChanges = dispatch(checkUnsavedChanges());
    if (hasUnsavedChanges && !navConfirmed) {
      setNextLocation(nextLocation.pathname);
      setRouterLeaveModal(true);
      return false;
    }
    navConfirmed = false;
    return true;
  };

  // websocket message receiver
  const callback = message => {
    if (message.body) {
      dispatch(_updateStatus(JSON.parse(message.body)));
    }
  }

  const connectSocket = () => {
    // websocket integration
    const socket = new WebSocket(socketURL);
    const stompClient = Stomp.over(socket)
    const topicUrl = `/topic/datahubSocket/${loginState.data.uid}/${activeAccountId}`
    stompClient.connect({}, () => {
      stompClient.subscribe(topicUrl, callback)
    })
  };

  useEffect(() => {
    connectSocket();
    props.router.setRouteLeaveHook(props.route, routerWillLeave);
  }, []);

  return (
    <React.Fragment>
      <DistributeView
        resetRouterLocation={resetRouterLocation}
        routerLeaveModal={routerLeaveModal}
        confirmNavigation={confirmNavigation}
      />
    </React.Fragment>
  );
};

Distribute.propTypes = {
  router: instanceOf(Object),
  route: instanceOf(Object),
};

export default withRouter(Distribute);
